import degreeToCardinal from './degreeToCardinal';
import getNavigatorCoords from './getNavigatorCoords';

export { default as coords } from './coords';
export { default as degreeToCardinal } from './degreeToCardinal';
export { default as getNavigatorCoords } from './getNavigatorCoords';
export default {
  degreeToCardinal,
  getNavigatorCoords,
};
